module.exports = __webpack_public_path__ + "img/1f3cd.d7d35c8.svg";